import dot from "dot-object";

// constants

// action_component_subject
const SET_DEPOSIT_WITHDRAWALS = "SET_DEPOSIT_WITHDRAWALS";
const RESET_DEPOSIT = "RESET_DEPOSIT";
const RESET_WITHDRAWALS = "RESET_WITHDRAWALS";

// reducers

const initialState = {
  deposit: {
    type: "paynow",
  },
  withdrawal: {
    type: "fund-transfers",
    paynow_number: "",
    fund_transfers: {
      bank_name: "",
      account_number: "",
    },
    comments: "",
  },
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DEPOSIT_WITHDRAWALS:
      let { key2, value } = action;
      let s = { ...state, [key2]: value };
      dot.object(s);

      return { ...s };

    case RESET_DEPOSIT:
      return { ...state, deposit: initialState.deposit };

    case RESET_WITHDRAWALS:
      return { ...state, withdrawal: initialState.withdrawal };
    default:
      return state;
  }
};

export default Reducer;

// actions

// const resolveAfter2Seconds = () => {
//   return new Promise((resolve) => {
//     setTimeout(() => {
//       resolve("resolved");
//     }, 2000);
//   });
// };

// action_component_subject
// export const decrementTestCounter = () => async (dispatch) => {
// 	const result = await resolveAfter2Seconds();
// 	console.log(result);
// 	dispatch({
// 		type: INCREMENT_TEST_COUNTER,
// 	});
// };

// action_component_subject, prefix set(not update),empty(not remove),hide,show
// export const incrementTestCounter = () => {
// 	return {
// 		type: INCREMENT_TEST_COUNTER,
// 	};
// };

export const setDepositWithdrawals = (key, value) => {
  return {
    type: SET_DEPOSIT_WITHDRAWALS,
    key2: key,
    value: value,
  };
};

export const resetDeposit = () => {
  return {
    type: RESET_DEPOSIT,
  };
};

export const resetWithdrawals = () => {
  return {
    type: RESET_WITHDRAWALS,
  };
};
